import { InfoCircleFilled } from '@ant-design/icons';
import { ModalTarifaClienteTmov } from '@sotran/lib-shipper';
import { Col, Row, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
  formatarMoeda,
  formatarMoedaIMask,
  formatarPorcentagem,
} from '../../../../helpers/formatador';
import { buscarHistorico } from '../../../../helpers/historicoCalculadora';
import {
  CardHistorico,
  Text,
  TextValor,
  TitleHistorico,
  Tooltip,
} from './styles';

export default function Calculadora({
  enderecos,
  icms,
  tarifaTmov,
  tarifaTmovCliente,
  isPercentualTmov,
  pedagio,
  descricaoProduto,
}) {
  const [historicoFrete, setHistoricoFrete] = useState({});
  const [showModalTarifa, setShowModalTarifa] = useState(false);

  useEffect(() => {
    async function onInit() {
      const { ibgeOrigem, ibgeDestino } = enderecos;

      if (!ibgeOrigem || !ibgeDestino) return;

      const dadosHistorico = await buscarHistorico(
        descricaoProduto,
        ibgeOrigem,
        ibgeDestino
      );

      if (dadosHistorico) setHistoricoFrete(dadosHistorico);
    }

    onInit();
  }, [enderecos, descricaoProduto]);

  function showModalTarifas() {
    setShowModalTarifa(true);
  }

  return (
    <>
      <Row>
        <TitleHistorico>Calculadora</TitleHistorico>
      </Row>
      <Row>
        <Col span={11}>
          <CardHistorico>
            <TitleHistorico>Parâmetros de valor</TitleHistorico>
            <Row justify="space-between">
              <Col>
                <Text>
                  {`Pedágio:
                    ${formatarMoedaIMask(pedagio)}
                    /ton`}
                </Text>
              </Col>
              <Col>
                <Text>{`ICMS: ${formatarPorcentagem(icms)}`}</Text>
              </Col>
              <Col>
                <Text>
                  {`Tarifa TMOV: ${
                    isPercentualTmov
                      ? formatarPorcentagem(tarifaTmov * 100)
                      : `${formatarMoeda(tarifaTmov)} /ton`
                  }`}
                </Text>
                <Tooltip placement="right">
                  <InfoCircleFilled
                    style={{
                      color: '#0D3567',
                      fontSize: '15px',
                    }}
                    onClick={showModalTarifas}
                  />
                </Tooltip>
              </Col>
            </Row>
          </CardHistorico>
        </Col>
        <Col span={12} offset={1}>
          <CardHistorico>
            <TitleHistorico>
              Para apoio, consulte os fretes motoristas abaixo:
            </TitleHistorico>
            <Space direction="vertical">
              <Text>Média do histórico frete:</Text>
              <TextValor>
                {formatarMoedaIMask(historicoFrete.mediaHistoricaFrete)}
              </TextValor>
              <Text>Média do valor atual do frete:</Text>
              <TextValor>
                {formatarMoedaIMask(historicoFrete.mediaAtualFrete)}
              </TextValor>
            </Space>
          </CardHistorico>
        </Col>
      </Row>
      <ModalTarifaClienteTmov
        tarifas={tarifaTmovCliente.tarifas}
        tipoTarifa={tarifaTmovCliente.tipoTarifa}
        visible={showModalTarifa}
        setVisible={setShowModalTarifa}
      />
    </>
  );
}

Calculadora.propTypes = {
  enderecos: PropTypes.shape({
    ibgeOrigem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ibgeDestino: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  pedagio: PropTypes.number.isRequired,
  icms: PropTypes.number.isRequired,
  tarifaTmov: PropTypes.number,
  tarifaTmovCliente: PropTypes.shape({
    tarifas: PropTypes.oneOfType([PropTypes.array]),
    tipoTarifa: PropTypes.string,
  }).isRequired,
  isPercentualTmov: PropTypes.bool,
  descricaoProduto: PropTypes.string,
};

Calculadora.defaultProps = {
  tarifaTmov: 0,
  isPercentualTmov: true,
  descricaoProduto: '',
};
